<script setup lang="ts">
  import type { UserProfileOut } from '@/shared/api/intranet'
  import { getImage } from '@/shared/lib/media'

  import { UserAvatar } from '@/entities/profile'

  const { profile } = defineProps<{
    profile: UserProfileOut
  }>()

  const fullName = computed(() => `${profile.firstName} ${profile.lastName}`)
</script>

<template>
  <RouterLink
    :to="{ name: '/profile/[id]/', params: { id: profile.id! } }"
    class="rounded-10 hover:bg-secondary-bg flex h-9 w-full items-center gap-2 px-3 py-1.5"
  >
    <UserAvatar
      :src="getImage({ id: profile.attachments?.[0], quality: 70 })"
      :size="20"
    />
    <span
      class="body-md-medium text-heading! truncate"
      :title="fullName"
    >
      {{ fullName }}
    </span>
  </RouterLink>
</template>
